'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

exports.default = {
  'illustration-phone-code': function illustrationPhoneCode(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 22.02 32' }, props),
      _react2.default.createElement('path', { fill: '#8c8c8c', d: 'M12.3692 3.4324l.0508-.1935 3.6076.9475-.0508.1934z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M1.54 22.68l14.44 3.79' }),
      _react2.default.createElement('path', {
        d: 'M7.39 0L.01 28.16 14.63 32l7.38-28.16zm7.1 31.76L.24 28l1.37-5.2 14.24 3.74zm1.42-5.41L1.66 22.61 6.58 3.85l14.25 3.74zM6.64 3.66l.9-3.42L21.78 4l-.9 3.42z',
        fill: '#8c8c8c' }),
      _react2.default.createElement('path', { d: 'M8.01 28.31a1 1 0 0 1-.26 0 1 1 0 1 1 .26 0zm0-1.87a.83.83 0 1 0 .21 0z', fill: '#8c8c8c' }),
      _react2.default.createElement('path', {
        d: 'M6.69 13.89l-.54-.32.2-.31.52.39.14-.65.37.1-.21.66.63-.08v.37h-.64l.26.6-.35.13-.2-.64-.48.44-.25-.28zm1.74.46L7.89 14l.2-.31.52.39.13-.66.37.1-.21.66.63-.08v.37h-.64l.26.6-.35.13-.2-.64-.48.44-.25-.28zm1.74.46l-.54-.32.2-.31.52.39.13-.66.37.1-.21.66.63-.08v.37h-.64l.26.6-.35.13-.2-.64-.48.44-.25-.28zm1.74.45l-.54-.32.2-.31.52.39.13-.66.37.1-.21.66.63-.12v.37h-.64l.26.6-.35.13-.2-.64-.48.44-.25-.28zm1.74.46l-.54-.32.2-.31.52.39.13-.66.37.1-.21.66.63-.08v.37h-.64l.26.6-.36.13-.2-.64-.48.44-.25-.28zm1.74.46l-.54-.32.2-.31.52.39.13-.66.37.1-.21.66.63-.08v.37h-.64l.26.6-.35.13-.2-.64-.48.44-.25-.28z',
        fill: '#26b8d1' })
    );
  },
  'illustration-phone-sms': function illustrationPhoneSms(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 22.02 32' }, props),
      _react2.default.createElement('path', { fill: '#8c8c8c', d: 'M12.3692 3.4324l.0508-.1935 3.6076.9475-.0508.1934z' }),
      _react2.default.createElement('path', {
        d: 'M7.39 0L.01 28.16 14.63 32l7.38-28.16zm7.1 31.76L.24 28l1.37-5.2 14.24 3.74zm1.42-5.41L1.66 22.61 6.58 3.85l14.25 3.74zM6.64 3.66l.9-3.42L21.78 4l-.9 3.42z',
        fill: '#8c8c8c' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M1.47 22.73l14.55 3.82' }),
      _react2.default.createElement('path', { fill: '#26b8d1',
        d: 'M14.15 14.43l-5.01-1.34.06-.23 5.01 1.34-.06.23m-.3 1.14l-5.02-1.34.06-.23 5.01 1.34-.05.23m-.31 1.14l-5.01-1.34.06-.23 5.01 1.34-.06.23' }),
      _react2.default.createElement('path', {
        d: 'M8.59 18.33l.4-1.5-1.98-.52 1.34-5 7.29 2-1.34 5-3.6-1zm2.13-1.28l3.42.92 1.22-4.56-6.84-1.83-1.22 4.56 1.94.52-.33 1.23z',
        fill: '#26b8d1' }),
      _react2.default.createElement('path', { d: 'M8.01 28.31a1 1 0 0 1-.26 0 1 1 0 1 1 .26 0zm0-1.87a.83.83 0 1 0 .21 0z', fill: '#8c8c8c' })
    );
  }
};

// presentational-star
// product-star
// flag-star
// logo-star
// star
//
// star(default-outlined)
// star-solid